import type { MarketId } from '../../../types';
import type { FiltersByOutcomeParameterMap, GlobalFilterOverrides, KeyComposedOfMarketAndFilters } from '../types';
import { buildNonNumericFiltersGroupKey } from './buildNonNumericFiltersGroupKey';

export const getKeyComposedOfMarketAndFilters = (
    marketId: MarketId,
    filtersMap: FiltersByOutcomeParameterMap,
    globalFilterOverrides: GlobalFilterOverrides,
): KeyComposedOfMarketAndFilters => {
    const filtersKey = buildNonNumericFiltersGroupKey(filtersMap, globalFilterOverrides);

    if (!filtersKey) {
        return String(marketId);
    }

    return `${marketId}|${filtersKey}`;
}
